import { Component, ElementRef, ViewChild } from '@angular/core';
// import { Base64ToGallery, Base64ToGalleryOptions } from '@ionic-native/base64-to-gallery/ngx';
import { Instagram } from '@awesome-cordova-plugins/instagram/ngx';
// import { Transfer, TransferObject } from '@ionic-native/transfer';
import {  LoadingController, NavController, Platform,} from '@ionic/angular';
import { Observable, Observer } from 'rxjs';
import { AppDetectorProvider } from '../../../providers/detector/detector';
import { EventProvider } from '../../../providers/event/event';
import { StatisticsResults } from '../../../providers/result/result';
import { SharingProvider } from '../../../providers/sharing/sharing';
import { GlobalUtil } from '../../../tracker/global-utils';
import { LocationHandlerUtil } from '../../../tracker/location-handler-utils';
import { GoogleMapsCreator, LeafletCreator, MapHandlerCreator } from '../../../tracker/map-factory/map-factory';
import { RunStatistics, WrappedStatistics } from '../../../tracker/run-statistics/run-statistics';

// import L from 'leaflet';
import * as  L from 'leaflet';
import * as LO from 'leaflet.offline';
import { IconPipe } from '../../../pipes/icon/icon';
import { DistanceUnit, TrackingService } from '../../../providers/tracking.service';
import { TranslateService } from '@ngx-translate/core';
import { TakeSelfiePage } from '../../me/mysport/mysport-results/mysport-results-menu/take-selfie/take-selfie';
import { Router } from '@angular/router';
import { CategoriesProvider } from '../../../providers/categories/categories';

declare var google;
declare var cordova: any;
declare var FileTransfer:any;

@Component({
  selector: 'page-result-description',
  templateUrl: 'result-description.html',
  styleUrls:['./result-description.scss']
})
export class ResultDescriptionPage {
  @ViewChild('map') mapElement: ElementRef;
  map: any;
  google: boolean = false;

  results: WrappedStatistics = null;
  registration: any;
  mapHandler: MapHandlerCreator = null;
  baseLayer;
  urlTemplate = 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png';
  totalAltitude = 0;
  finishMarker;
  startMarker;
  routerState:any;

  constructor(
    private appDetector: AppDetectorProvider,
    public detector: AppDetectorProvider,
    private instagram: Instagram,
    // private base64ToGallery: Base64ToGallery,
    private sharingService: SharingProvider,
    private translate: TranslateService,
    public navCtrl: NavController,
    private platform: Platform,
    private eventService: EventProvider,
    public trackingService: TrackingService,
    private router:Router,
    private icons: IconPipe,
    private loadingCtrl: LoadingController,
    private categoriesProvider:CategoriesProvider
  ) {
    const nav = this.router.getCurrentNavigation();
    this.routerState = nav?.extras?.state || {};
  }

  public get distanceUnit(): typeof DistanceUnit {
    return DistanceUnit;
  }

  removeUncomplitedKm() {
    const tDistance = Math.floor(this.results.totalDistance / 1000);
    const kmArrLength = this.results.kmStatistics.length;
    // this.totalAltitude = Math.floor(LocationHandlerUtil.calcAltitude(this.results.kmStatistics.map((r) => r.elevation)));
    this.totalAltitude = this.calcAltitude();
    if (tDistance < kmArrLength) {
      this.results.kmStatistics = Object.assign([], this.results.kmStatistics.slice(0, kmArrLength - 1));
    }
  }

  ionViewDidEnter() {
    
    this.results = this.routerState["statisticsResults"];
    this.registration = this.routerState["registration"];
    this.removeUncomplitedKm();
    this.loadLeafletMaps();
  }

  loadMaps() {
    console.log('loadMaps: ');
    try {
      this.platform.ready().then(() => {
        var that = this;
        let loadMaps = setInterval(() => {
          if (typeof google !== "undefined") {

            let mapConfig = {
              zoom: 15,
              center: { lat: 52.5204345, lng: 13.4014027 },
              mapTypeId: google.maps.MapTypeId.TERRAIN,
              disableDefaultUI: true
            };

            that.mapHandler = new GoogleMapsCreator(new google.maps.Map(that.mapElement.nativeElement, mapConfig));

            this.drawLinesGoogle();

            let bounds = new google.maps.LatLngBounds();

            let coords = this.results.routePoints || [];

            for (let i = 2; i < coords.length - 2; i++) {
              if (coords[i].lat() !== undefined && coords[i].lng() !== undefined) {
                let LatLng = new google.maps.LatLng(coords[i].lat(), coords[i].lng());
                bounds.extend(LatLng);
              }

            }

            that.mapHandler.getMap().fitBounds(bounds);

            this.setMapCenter();

            clearInterval(loadMaps);
          }
        }, 400);
      });
    } catch (err) {
      console.log('loadMaps error = ' + err);
    }
  }

  async loadLeafletMaps() {
    this.map = L.map('mapid');

    this.baseLayer = (L as any).tileLayer
      .offline(this.urlTemplate, {
        attribution: 'Map data {attribution.OpenStreetMap}',
        subdomains: 'abc',
        minZoom: 1,
      })
      .addTo(this.map);

    this.map.setView(
      {
        lat: 52.5204345,
        lng: 13.4014027,
      },
      15,
    );

    // add buttons to save tiles in area viewed
    const control = (L as any).control.savetiles(this.baseLayer, {
      zoomlevels: [1, 35], // optional zoomlevels to save, default current zoomlevel
      confirm(layer, successCallback) {
        // eslint-disable-next-line no-alert
        // if (window.confirm(`Save ${layer._tilesforSave.length}`)) {
        successCallback();
        // }
      },
      confirmRemoval(layer, successCallback) {
        // eslint-disable-next-line no-alert
        if (window.confirm('Remove all the tiles?')) {
          successCallback();
        }
      },
      saveText:
        '<i class="fa fa-download" aria-hidden="true" title="Save tiles"></i>',
      rmText: '<i class="fa fa-trash" aria-hidden="true"  title="Remove tiles"></i>',
    });
    control.addTo(this.map);

    this.mapHandler = new LeafletCreator(this.map);

    let progress;
    this.baseLayer.on('savestart', (e) => {
      progress = 0;
      console.log(e._tilesforSave.length);
    });
    this.baseLayer.on('savetileend', () => {
      progress += 1;
      console.log("progress: " + progress);
    });

    this.drawStartFinishMarkers(this.results.hasRoute);

    if (this.results.hasRoute) {
      this.mapHandler.newPoly();
      this.mapHandler.setPolyDestinations(this.results.routePoints);
      this.mapHandler.drawPolyLines(true);
      this.mapHandler.setMapCenterLatLng(this.results.routePoints[0]);
      this.mapHandler.setMapCenterZoom(12);
    } else {
      this.drawLinesLeaflet();
      this.boundLeaflet();
      this.setMapCenter();
    }
  }

  async drawStartFinishMarkers(hasRoute) {
    let coords = [];
    coords.push(this.results.routePoints[0]);
    coords.push(this.results.routePoints[this.results.routePoints.length - 1]);
    let icons = {};

    if (this.appDetector.isForestApp()) {
      icons = {
        start: await this.icons.get('markergo', ''),
        finish: await this.icons.get('markergo', '')
      };
    } else {
      icons = {
        start: await this.icons.transform(this.results.eventCid + '', 'marker'),
        finish: await this.icons.get('marker', 'finish')
      };
    }

    if (hasRoute) {
      console.log('drawMarkers - 4.1');
      this.mapHandler.drawStartFinishMarkersLatLng(coords, icons);
    } else {
      console.log('drawMarkers - 4.2');
      this.mapHandler.drawStartFinishMarkersArray(coords, icons);
    }
  }

  boundLeaflet() {
    let markerArray = [];
    for (let i = 0; i < this.results.routePoints.length; i++) {
      markerArray.push(L.marker([this.results.routePoints[i][0], this.results.routePoints[i][1]]));
    }
    let group = L.featureGroup(markerArray);
    this.map.fitBounds(group.getBounds());
  }

  calcAltitude() {
    //
    //return Math.floor(this.results.kmStatistics.map(x => x.gain).reduce((acc, curr) => acc + curr, 0));
    return LocationHandlerUtil.calcAltitude(this.results.kmStatistics.map(x => x.gain));
  }

  onResultsRedirect() {
    if (this.appDetector.isHellaApp()) {
      this.eventService.getPage(`event/${GlobalUtil.getInstance().currentEventID}/raceresult/url`).then((res) => {
        if (res.length < 1) {

        }

        // (this.app.getRootNav() as NavController).push(InBrowserPage, { link: res });
        this.navCtrl.navigateForward('/in-browser', {state:{link: res}});
      });
    } else if (this.appDetector.isThurnauApp()) {
      // (this.app.getRootNav() as NavController).popToRoot();
      // this.app.getRootNav().getActiveChildNav().select(2);
      this.navCtrl.navigateForward('/tab2');
    }
  }

  onTrainingRedirect() {
    this.navCtrl.navigateForward('/tab5');
    // (this.app.getRootNav() as NavController).popToRoot().then(() => {
    //   this.app.getRootNav().getActiveChildNav().select(3);
    // })
  }

  drawLinesGoogle() {
    const points = this.results.routePoints || [];
    if (points.length > 1) {
      this.mapHandler.setPolyDestinations(points);
      this.mapHandler.drawPolyLines(true);
    }
  }

  drawLinesLeaflet() {
    const points = this.results.routePoints || [];
    console.log('points.length: ' + points.length);
    if (points.length > 1) {
      console.log('draw - 2');
      this.mapHandler.setPolyDestinations(points);
      this.mapHandler.drawPolyLines(true);
    }
  }

  setMapCenterLatLng() {
    const points = this.results.routePoints || [];
    if (points.length > 1) {
      this.mapHandler.setMapCenterLatLng(points[points.length - 1]);
    }
  }

  setMapCenter() {
    console.log('center - 1');
    const points = this.results.routePoints || [];
    if (points.length > 1) {
      console.log('center - 2');
      this.mapHandler.setMapCenter(points[points.length - 1], 12);
    }
  }

  loader;
  shareFacebook() {
    this.showSelfiePage();
  }

  shareInstagram() {
    this.showSelfiePage();
  }

  showSelfiePage() {
    const currentDate = new Date();
    const day = String(currentDate.getDate()).padStart(2, '0');
    const month = String(currentDate.getMonth() + 1).padStart(2, '0'); // Months are zero-based, so we add 1.
    const year = currentDate.getFullYear();
    let categoryIndex  = -1;
    let category = "";
    this.categoriesProvider.getEventCategoires().then(eventCategories=>{
      categoryIndex = eventCategories.findIndex(c => c.id == this.results.eventCid);
      if (categoryIndex > -1) {
        category = eventCategories[categoryIndex].name;
      }
    })

    const eventDate = `${day}.${month}.${year}`;
    const distance = this.trackingService.options.distanceUnit == this.distanceUnit.KM ?
      (this.results.totalDistance / 1000).toFixed(2) + " km"
      :
      (this.results.totalDistance / 1000 * 0.621371).toFixed(2) + ' ' + this.translate.instant('MILES');

    let resultDetails = {
      distance: distance,
      time: this.results.totalTimeFormatted,
      place: "",
      eventDate: eventDate,
      cid: category,
      eventName: "",
      logo: "assets/imgs/goforest/white.png"
    };

    this.navCtrl.navigateForward('/tab2/take-selfie', {state:{esultDetails: resultDetails}});
    // (this.app.getActiveNav() as NavController).push(TakeSelfiePage, { resultDetails: resultDetails });
  }

  // convertToImage(image) {
  //   let config: Base64ToGalleryOptions = {
  //     prefix: 'img_',
  //     mediaScanner: true
  //   };
  //   this.base64ToGallery.base64ToGallery(image, config).then(
  //     res => {
  //       this.downloadFile(null);
  //     },
  //     err => console.log('Error saving image to gallery ', err)
  //   );
  // }

  // downloadFile(link) {
  //   this.platform.ready().then(() => {

  //     const fileTransfer: TransferObject = this.transfer.create();

  //     let storageDirectory = "";

  //     const imageLocation = this.registration.imageLink;

  //     if (this.platform.is('ios')) {
  //       storageDirectory = cordova.file.documentsDirectory;
  //     }
  //     else if (this.platform.is('android')) {
  //       storageDirectory = cordova.file.dataDirectory;
  //     }

  //     let image = imageLocation + ".jpeg";

  //     fileTransfer.download(imageLocation, storageDirectory + image).then((entry) => {
  //       this.loader.dismiss();
  //       this.instagram.shareAsset(entry.toURL()).then(() => {
  //       });
  //     }, (error) => {
  //       console.log(error);
  //     });

  //   });
  // }

  // getBase64ImageFromURL(url: string) {
  //   return Observable.create((observer: Observer<string>) => {
  //     let img = new Image();
  //     img.crossOrigin = 'Anonymous';
  //     img.src = url;
  //     if (!img.complete) {
  //       img.onload = () => {
  //         observer.next(this.getBase64Image(img));
  //         observer.complete();
  //       };
  //       img.onerror = (err) => {
  //         observer.error(err);
  //       };
  //     } else {
  //       observer.next(this.getBase64Image(img));
  //       observer.complete();
  //     }
  //   });
  // }

  // getBase64Image(img: HTMLImageElement) {
  //   var canvas = document.createElement("canvas");
  //   canvas.width = img.width;
  //   canvas.height = img.height;
  //   var ctx = canvas.getContext("2d");
  //   ctx.drawImage(img, 0, 0);
  //   var dataURL = canvas.toDataURL("image/png");
  //   return dataURL.replace(/^data:image\/(png|jpg);base64,/, "");
  // }

}
